module.exports = __webpack_public_path__ + "img/c5a439b.jpg";